import React from 'react';
import { Button } from 'antd';
import { Input, Modal } from "antd";



const RejectModal = ({ rejectModalOpen, setRejectModalOpen, rejectRemark, setRejectRemark, actionLoading, handleReject }) => {

  return (<Modal
    open={rejectModalOpen}
    onCancel={() => setRejectModalOpen(false)}
    footer={null}
    closable={false}
    centered
    bodyStyle={{ padding: 32, borderRadius: 16 }}
  >
    <div style={{ textAlign: 'center', fontWeight: 600, fontSize: 24, marginBottom: 24 }}>
      Are you sure to Reject?
    </div>
    <div style={{ marginBottom: 16, textAlign: 'left', fontWeight: 500 }}>Remarks</div>
    <Input.TextArea
      value={rejectRemark}
      onChange={e => setRejectRemark(e.target.value)}
      rows={4}
      style={{ marginBottom: 32, resize: 'none' }}
      placeholder="Enter remarks"
    />
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
      <Button
        onClick={() => setRejectModalOpen(false)}
        style={{
          minWidth: 80,
          background: '#F5F5F5',
          color: '#222',
          border: 'none',
          fontWeight: 500,
        }}
        disabled={actionLoading}
      >
        No
      </Button>
      <Button
        type="primary"
        danger
        style={{
          minWidth: 80,
          fontWeight: 500,
          background: '#FF4D4F',
          borderColor: '#FF4D4F'
        }}
        onClick={handleReject}
        loading={actionLoading}
        disabled={!rejectRemark.trim()}
      >
        Yes
      </Button>
    </div>
  </Modal>)
}

export default RejectModal;